import { useContext } from 'react'
import PleasWaitContext from '../context/PleaseWaitProvider';

const usePleaseWait = () => {
    return useContext(PleasWaitContext);
}

export default usePleaseWait